import { useContext } from 'react';
import type { QuantAnalysis } from '@/types';
import { ProjectDetailsContext } from '../Context';

export const useProjectQuantAnalyses = (): QuantAnalysis[] => {
  const ctx = useContext(ProjectDetailsContext);
  
  return ctx.query.data?.project?.quantAnalyses || [];
};
